import fetch from "./../../helpers/fetch";
import params from "./../../lib/params";

// 分配模式列表
export function getAllotModel(content) {
  return fetch.get("/api/config/index", content);
}

// 分配模式编辑
export function setAllotModel(content) {
  return fetch.post("/api/config/update", null, {
    body: params(content),
  });
}

// 获取分配名单
export function getAllotUser(content) {
  return fetch.get("/api/config/user", content);
}

// 删除某个名单
export function deleteUser(content) {
  return fetch.get("/api/config/delete", content);
}

// 添加名单
export function checkoutUser(content) {
  return fetch.post("/api/config/check-user", null, {
    body: params(content),
  });
}

//配置资源资源分配设置
export function setFrontedAllocation(content) {
  return fetch.post("/api/config/set-fronted-allocation", null, {
    body: params(content),
  });
}

//小额app后端分配模式设置
export function setCheckDepartment(content) {
  return fetch.post("/api/config/check-department", null, {
    body: params(content),
  });
}
//后端分配人员列表
export function getBackEndUserList(content) {
  return fetch.get("/api/config/backend-users", content);
}

//后端分配部门列表
export function getBackEndDepList(content) {
  return fetch.getFast("/api/queue/backend-dep-list", content);
}

//员工分配权重设置
export function setWeightSet(content) {
  return fetch.post("/api/config/allocation-weight-set", null, {
    body: params(content),
  });
}

//获取组剩余量
export function getBackEndGroupLave(content) {
  return fetch.get("/api/config/backend-group-lave", content);
}

//员工分配次数设定
export function seAllocationtTimes(content) {
  return fetch.post("/api/config/backend-allocation-times-set", null, {
    body: params(content),
  });
}
